import { injectIntercom, IntercomInitData } from 'shared/lib/intercom';
import { getAmpConfig } from 'shared/config/amp-config';
import { Org, User } from 'shared/api/onboarding';
import { AuthService } from 'shared/lib/keycloak';

export const fetchIntercomUserHash = (token: string) => {
  const url = `${getAmpConfig().thirdPartySecrets}/intercom/keycloakUserHash`;
  return fetch(url, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch((e) => {
      throw new Error(`Couldn't load user hash: ${e}`);
    });
};

export const fetchUserInfo = (token: string, userBk: string) => {
  const url = `${getAmpConfig().onboarding}/ims/oneroster/v1p1/users/${userBk}`;
  return fetch(url, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch((e) => {
      throw new Error(`Couldn't load user info: ${e}`);
    });
};

const getOrgByType = (type: string, userData: Partial<User>) =>
  userData.orgs?.find((o: Org) => o.orgType === type);

export const buildIntercomArgs = (initData: IntercomInitData) => {
  const school = getOrgByType('school', initData.userDetails);
  const district = getOrgByType('district', initData.userDetails);

  return {
    app_id: getAmpConfig().intercomId,
    user_id: initData.profile.email,
    user_hash: initData.userHash,
    email: initData.profile.email,
    name: `${initData.profile.firstName} ${initData.profile.lastName}`,
    first: initData.profile.firstName,
    last: initData.profile.lastName,
    products: 'Teacher home',
    school: school?.name ?? 'No school provided',
    district: district?.name ?? 'No district provided',
    district_id: district?.sourcedId ?? 'No district provided',
    hide_default_launcher: true,
  };
};

export const initIntercom = async (onboardingUserInfo: User) => {
  // do not init if user is read-only
  if (AuthService.isReviewer()) {
    return;
  }

  await injectIntercom();

  try {
    const token = AuthService.getAccessToken();

    const profile = await AuthService.getUserProfile();
    const hash = await fetchIntercomUserHash(token);

    if (profile.id === undefined) {
      return;
    }

    const intercomArgs = buildIntercomArgs({
      profile,
      userHash: hash?.key,
      userDetails: onboardingUserInfo,
    });

    window.Intercom('boot', intercomArgs);
  } catch (e) {
    console.error(`Could not init intercom: ${e}`);
  }
};
